import moment from "moment";

export default {
    checkController(arr, controller, action) {
        if (arr && arr.permissions) {
            return arr.permissions.some(function (el) {
                return (
                    el.controller.toLowerCase() === controller.toLowerCase() &&
                    el.action.toLowerCase() === action.toLowerCase()
                );
            });
        }
    },

    checkRolesPermissions(roles, controller, action) {
        if (roles && roles.length > 0) {
            return (
                roles.filter(
                    (role) =>
                        role.permissions.filter(
                            (el) =>
                                el.controller.toLowerCase() ===
                                    controller.toLowerCase() &&
                                el.action.toLowerCase() === action.toLowerCase()
                        ).length > 0
                ).length > 0
            );
        }
    },

    formatPrice(price) {
        const formatter = new Intl.NumberFormat("it-IT", {
            style: "currency",
            currency: "EUR",
        });
        return formatter.format(price);
    },

    // Grouping permissions by controller
    groupByController(array) {
        return array.reduce((result, currentValue) => {
            (result[currentValue.controller.toLowerCase()] =
                result[currentValue.controller.toLowerCase()] || []).push(
                currentValue
            );
            return result;
        }, {});
    },

    // Check if there are permisions on an existing role to change checked to true
    checkExistingId(permissions, listPermissions) {
        permissions.forEach((b) => {
            listPermissions.forEach((a) => {
                if (b.id == a.id) {
                    a.checked = true;
                }
            });
        });
        return listPermissions;
    },

    getPageSize(paginator, total) {
        let to = null;
        if (total <= paginator.pageSize * paginator.pageNumber) to = total;
        else to = paginator.pageNumber * paginator.pageSize;

        const paginationCalculated = {
            total: total,
            perPage: paginator.pageSize,
            currentPage: paginator.pageNumber,
            lastPage: Math.ceil(total / paginator.pageSize),
            from: (paginator.pageNumber - 1) * paginator.pageSize + 1,
            to: to,
        };
        return paginationCalculated;
    },

    buildQs(qs) {
        let search;
        let sort_by;

        const empty = Object.values(qs.filters).every(
            (x) => x === null || x === ""
        );

        if (!empty) {
            let last = Object.keys(qs.filters)[
                Object.keys(qs.filters).length - 1
            ];

            for (const [key, value] of Object.entries(qs.filters)) {
                if (value !== null && value !== "") {
                    if (search) search += `${key}:${value}`;
                    else search = `${key}:${value}`;
                    if (key !== last) search += ",";
                }
            }
        }

        // check if SORT object is empty
        const isEmpty = Object.keys(qs.sort).length === 0;

        if (!isEmpty) {
            let last = Object.keys(qs.sort)[Object.keys(qs.sort).length - 1];
            for (const [key, value] of Object.entries(qs.sort)) {
                if (sort_by) sort_by += `${key}:${value}`;
                else sort_by = `${key}:${value}`;
                if (key !== last) sort_by += ",";
            }
        }

        const params = {
            pageIndex: qs.pageIndex,
            pageSize: qs.pageSize,
        };

        if (search) params.search = search;
        else delete params.search;

        if (sort_by) params.sort_by = sort_by;
        else delete params.sort_by;
        return Object.entries(params)
            .map(([key, val]) => {
                if (val !== undefined && val !== null && val !== "")
                    return `${key}=${encodeURIComponent(val)}`;
            })
            .filter(Boolean)
            .join("&");
    },

    getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    },

    dateFormat(date, format) {
        if (date) return moment.utc(date).format(format);
    },

    formatDate(date) {
        if (date) return moment.utc(date).toISOString();
    },
};
